<template>
	<Body class="graybg" />
	<ClientOnly>
		<div class="auth-wrapper">
			<div class="col col1">
				<div class="col-cnt">
					<slot name="col1" />
				</div>
			</div>
			<div class="col col2">
				<slot name="col2" />
			</div>
		</div>
	</ClientOnly>
</template>

<script setup>

</script>

<style scoped lang="less">
	.auth-wrapper{
		width: 1060px; margin: auto; display: flex; padding: 50px 0 75px; gap: 90px;
		@media (max-width: @t){width: 760px; padding: 30px 0 40px; gap: 30px;}
		@media (max-width: @m){width: 100%; padding: 0; gap: 0; flex-flow: column;}	
	}
	.col1{
		flex: 0 0 580px; position: relative;
		&:before{.pseudo(auto, 50px); background: var(--blue2); bottom: -12px; left: 80px; right: 80px; border-radius: 8px;}
		@media (max-width: @t){flex: 0 0 390px;}
		@media (max-width: @m){
			flex: 0 0 100%; 
			&:before{display: none;}	
		}
	}
	.col-cnt{
		background: #fff; border-radius: 12px; padding: 70px 80px; box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1); position: relative; height: 100%; z-index: 1;
		@media (max-width: @t){padding: 24px;}
		@media (max-width: @m){padding: 29px 16px; border-radius: 0; box-shadow: none;}	
	}
	.col2{
		@media (max-width: @m){padding: 29px 16px;}
	}
</style>